import styled from "@emotion/styled";
import { row } from "@ui/style";
import { colors } from "@ui/style/colors";
import React, { ReactNode } from "react";

interface AnimatedHaloProps {
	shouldDisplayHalo?: boolean;
	children?: ReactNode;
}

export const AnimatedHalo: React.FC<AnimatedHaloProps> = ({ shouldDisplayHalo = true, children }) => (
	<MainContainer shouldDisplayHalo={shouldDisplayHalo}>{children}</MainContainer>
);

const MainContainer = styled.div<{ shouldDisplayHalo?: boolean }>`
	${row(0)}
	border: ${({ shouldDisplayHalo }) => (shouldDisplayHalo ? "3px solid transparent" : "none")};
	border-radius: 40px;

	animation: ${({ shouldDisplayHalo }) => (shouldDisplayHalo ? "haloAnimation 2s infinite running" : "none")};
	animation-delay: 0.5s;
	animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
	@keyframes haloAnimation {
		0% {
			outline: 1px solid ${colors.onboardingPrimary};
			border: 3px solid ${colors.onboardingPrimary};
		}
		100% {
			outline: 30px solid rgba(160, 85, 240, 0.0001);
			border: 3px solid ${colors.onboardingPrimary};
		}
	}
`;
